export default {
  search: {
    pagination: {
      page_quantity: 'Paginar de a',
      show_quantity_records: 'Mostrando {{model}} {{beginRecords}} - {{endRecords}} de {{total}} en total',
      show_total_records: 'Mostrando {{total}} {{model}}'
    },
    new_pagination: {
      show_quantity_records: '{{beginRecords}} - {{endRecords}} de {{total}} en total'
    },
    filter: {
      badge_content: {
        filter_searched: 'Tus parámetros de búsqueda son:',
        filter_configuration: 'Configuración de filtros',
        text_searched_title: 'El texto que buscó fue:',
        validation_message: 'Escribe al menos 3 caracteres',
        hint: ' Renombra tu búsqueda y guárdala'
      }
    }
  }
};
